import React from "react";
type VesselProps = React.PropsWithChildren<{}>;
function Vessel({ children }: VesselProps) {
	return <div className="h-full">{children}</div>;
}

export default Vessel;
